// @flow

export const HABIT_TYPES = {
  member: 'member',
  user: 'user',
};
